import React from 'react';
import Form from 'react-bootstrap/Form';
import MultiSelect from '../inputs/multi-select';
import { useSelector } from 'react-redux';

export default function TargetAccountSelector({
    connections = [],
    selectedConnection,
    onChange,
    disabled,
    filterPlatform,
    isPushModal = false,
    dataCyDropdown = "sync-connection-dropdown"
}) {
    const entitlements = useSelector(state => state.user.entitlements) || {};
    const targetPlatform = filterPlatform;

    const availableConnections = (connections || []).filter(conn => {
        if (targetPlatform && conn.platform !== targetPlatform) {
            return false;
        }
        if (isPushModal) {
            if (conn.platform === 'xero' && entitlements.xeroPush === false) return false;
            if (conn.platform === 'quickbooks' && entitlements.qboPush === false) return false;
            if (conn.platform === 'myob' && entitlements.myobPush === false) return false;
        }
        return true;
    });

    if (!availableConnections || availableConnections.length === 0) {
        return (
            <div className="form-group w-100 mb-3" data-cy="target-account-no-connections">
                <Form.Label>Target Account</Form.Label>
                <div className="text-muted border p-2 rounded bg-light" style={{ fontSize: '0.85rem' }}>
                    {isPushModal ? "No push-enabled target accounts available under your subscription plan." : "No connections found. Please configure them in Settings."}
                </div>
            </div>
        );
    }

    const items = availableConnections.map(conn => {
        const platformLabel = conn.platform === 'xero' ? 'Xero' : conn.platform === 'quickbooks' ? 'QuickBooks' : 'MYOB';
        const displayName = conn.display_name || conn.platform_connection_name || conn.platform;
        return {
            value: conn.id,
            label: (
                <div className="d-flex justify-content-between align-items-center w-100 gap-2">
                    <span>{platformLabel} - {displayName}</span>
                    {conn.is_default && (
                        <span className="badge bg-success rounded-pill badge-default-pill">Default</span>
                    )}
                </div>
            )
        };
    });

    const selectedValue = selectedConnection ? {
        value: selectedConnection.id,
        label: (
            <div className="d-flex justify-content-between align-items-center w-100 gap-2">
                <span>
                    {selectedConnection.platform === 'xero' ? 'Xero' : selectedConnection.platform === 'quickbooks' ? 'QuickBooks' : 'MYOB'} - {selectedConnection.display_name || selectedConnection.platform_connection_name || selectedConnection.platform}
                </span>
                {selectedConnection.is_default && (
                    <span className="badge bg-success rounded-pill badge-default-pill">Default</span>
                )}
            </div>
        )
    } : null;

    return (
        <div className="mb-3 w-100">
            <MultiSelect
                label="Target Account"
                placeholder="Select Connection"
                isMulti={false}
                className="mb-0"
                data-cy={dataCyDropdown}
                isDisabled={disabled}
                items={items}
                value={selectedValue}
                onChangeHandler={(option) => {
                    const selected = availableConnections.find(c => String(c.id) === String(option?.value));
                    onChange(selected || null);
                }}
            />
        </div>
    );
}
